import {invalidateQueries, q} from "../../state";
import {CreateTprmScope, DataRoom, DataRoomId, TprmScopeMin, TprmExternalQuestionnaireMin} from "../../Types";
import {CURRENT_REGION} from "../../utils/region";
import jsonApi from "../jsonApi";

export async function get(dataRoomId: DataRoomId): Promise<DataRoom> {
  return jsonApi.get<DataRoom>(`/region/${CURRENT_REGION}/api/tprm/data_rooms/${dataRoomId}`);
}

export async function listScopes(dataRoomId: DataRoomId): Promise<TprmScopeMin[]> {
  return jsonApi.get<TprmScopeMin[]>(`/region/${CURRENT_REGION}/api/tprm/data_rooms/${dataRoomId}/scopes`);
}

export async function createScope(dataRoomId: DataRoomId, scope: CreateTprmScope): Promise<string> {
  const res = await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/tprm/data_rooms/${dataRoomId}/scopes`, scope);
  await invalidateQueries([q.tprm.dataRoomScopes.filter(dataRoomId)]);
  return res;
}

export async function listExternalQuestionnaires(dataRoomId: DataRoomId): Promise<TprmExternalQuestionnaireMin[]> {
  return await jsonApi.get<TprmExternalQuestionnaireMin[]>(
    `/region/${CURRENT_REGION}/api/tprm/data_rooms/${dataRoomId}/external_questionnaires`,
  );
}
